module.exports = __webpack_public_path__ + "static/img/QA.91b35ecb.png";